import { useState, useEffect } from 'react';

// Local imports
import { VideoCardList } from "./StudentDashboard";
import LoadingIcon from "./loading/LoadingIcon";
import Error from './Error';
import { fetchSingAlongs } from '../api/course-service';
import { VIDEO_TYPES } from '../constants';

const SingAlongs = () => {
    const [ singAlongs, setSingAlongs ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const [ error, setError ] = useState(null)

    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const data = await fetchSingAlongs();
                setLoading(false);
                setSingAlongs(data);
            } catch (err) {
                setLoading(false);
                console.error(err)
                setError(err.message)
            }
        }
        fetchVideos();
    }, [])

    if (loading) {
        return <LoadingIcon />
    }

    if (error) {
        return <Error message={error} />
    }

    return (
        <div>
            <h1>Sing-Alongs</h1>
            {!singAlongs || singAlongs.length === 0 ? (
                <p>No videos found.</p>
            ) : (
                <VideoCardList videos={singAlongs} videoType={VIDEO_TYPES.SING_ALONG} />
            )}
            
        </div>
    )
}

export default SingAlongs;